/**
 * HTML Utilities
 * Safe HTML manipulation functions
 *
 * @module HtmlUtils
 * Sprint 32: OOA/OOD Refactoring
 */

/**
 * Escape HTML entities to prevent XSS
 */
export function escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

/**
 * Safely replace Feather icons without breaking execution
 */
export function safeFeatherReplace(): void {
    if (typeof window !== 'undefined' &&
        (window as any).feather &&
        typeof (window as any).feather.replace === 'function') {
        try {
            (window as any).feather.replace();
        } catch (error) {
            console.warn('Feather icons replace failed (non-fatal):', (error as Error).message);
        }
    }
}

/**
 * Sleep utility for delays
 */
export function sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Generate a unique message ID
 */
export function generateMessageId(): string {
    return `msg-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Scroll an element to the bottom
 */
export function scrollToBottom(element: HTMLElement | null): void {
    if (element) {
        element.scrollTop = element.scrollHeight;
    }
}

/**
 * Get element by ID with type casting
 */
export function getElementById<T extends HTMLElement>(id: string): T | null {
    return document.getElementById(id) as T | null;
}
